export default {
  'cashMovement.form.company': 'Companies',
  'cashMovement.form.bankAccount': 'Bank Accounts',
  'cashMovement.form.timeCourse': 'Time Course',
  'cashMovement.form.until': 'Until',
  'cashMovement.button.updateData': 'Update Data',
  'cashMovement.view.previousBalance': 'Previous Balance',
  'cashMovement.view.totalOutputs': 'Total Outputs',
  'cashMovement.view.totalEntries': 'Total Entries',
  'cashMovement.view.totalBalance': 'Saldo Balance',

  'cashMovement.form.table.installmentCode': 'Installment Code',
  'cashMovement.form.table.launch': 'Launch',
  'cashMovement.form.table.description': 'Description',
  'cashMovement.form.table.documentNumber': 'Document Number',
  'cashMovement.form.table.entry': '(+) Entry',
  'cashMovement.form.table.exit': '(-) Exit',
};
